import { type CSSProperties } from 'react';

export const FONT_STACK = "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif";

export const EMBED_CSS = `
.tc-embed input::placeholder,
.tc-embed textarea::placeholder { color: #9ca3af; }
.tc-embed input:focus,
.tc-embed textarea:focus {
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);
}
.tc-embed button[type="submit"]:hover:not(:disabled) { background: #1d4ed8; }
.tc-embed button[type="submit"]:disabled { opacity: 0.6; cursor: not-allowed; }
.tc-embed button[type="button"]:hover { background: #f5f5f5; border-color: #c4c4c4; }
.tc-grid-2 {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 16px;
}
@media (max-width: 760px) {
  .tc-grid-2 {
    grid-template-columns: minmax(0, 1fr);
  }
  /* 16px minimum prevents iOS Safari auto-zoom; !important beats the inline 14px */
  .tc-embed input,
  .tc-embed textarea,
  .tc-embed select {
    font-size: 16px !important;
  }
}
`;

export const styles: Record<string, CSSProperties> = {
  shell: {
    fontFamily: FONT_STACK,
    background: '#ffffff',
    color: '#1a1a1a',
    minHeight: '100vh',
    padding: '16px',
  },
  card: {
    maxWidth: '640px',
    margin: '0 auto',
    background: '#ffffff',
    borderRadius: '12px',
    border: '1px solid #e5e5e5',
    boxShadow: '0 1px 2px rgba(0, 0, 0, 0.04)',
    padding: '24px',
  },
  form: {
    display: 'grid',
    gap: '16px',
  },
  label: {
    display: 'grid',
    gap: '6px',
    fontSize: '14px',
    fontWeight: 500,
    color: '#1a1a1a',
  },
  input: {
    border: '1px solid #d9d9d9',
    borderRadius: '8px',
    padding: '9px 12px',
    fontSize: '14px',
    color: '#1a1a1a',
    background: '#ffffff',
    width: '100%',
    boxSizing: 'border-box',
    outline: 'none',
    fontFamily: 'inherit',
  },
  textarea: {
    border: '1px solid #d9d9d9',
    borderRadius: '8px',
    padding: '9px 12px',
    fontSize: '14px',
    color: '#1a1a1a',
    background: '#ffffff',
    width: '100%',
    boxSizing: 'border-box',
    outline: 'none',
    resize: 'vertical',
    fontFamily: 'inherit',
  },
  submitButton: {
    marginTop: '4px',
    background: '#2563eb',
    border: 'none',
    color: '#ffffff',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: 600,
    padding: '10px 16px',
    cursor: 'pointer',
    fontFamily: 'inherit',
    transition: 'background 0.15s ease',
  },
  inlineError: {
    background: '#fef2f2',
    color: '#dc2626',
    border: '1px solid #fecaca',
    borderRadius: '8px',
    padding: '10px 12px',
    fontSize: '13px',
  },
  loading: {
    padding: '28px',
    textAlign: 'center',
    color: '#666666',
    fontFamily: FONT_STACK,
    fontSize: '14px',
  },
  error: {
    padding: '24px',
    color: '#dc2626',
    fontFamily: FONT_STACK,
    fontSize: '14px',
  },
  successWrap: {
    maxWidth: '640px',
    margin: '0 auto',
    padding: '28px 24px',
    textAlign: 'center',
    fontFamily: FONT_STACK,
    color: '#166534',
    background: '#f0fdf4',
    border: '1px solid #bbf7d0',
    borderRadius: '12px',
  },
  successTitle: {
    marginTop: 0,
    marginBottom: '10px',
    fontSize: '18px',
    fontWeight: 600,
  },
  successText: {
    marginTop: '6px',
    marginBottom: '6px',
    fontSize: '14px',
    color: '#15803d',
  },
  honeypot: {
    position: 'absolute',
    left: '-10000px',
    width: '1px',
    height: '1px',
    opacity: 0,
  },
  linkSection: {
    border: '1px solid #e2e8f0',
    borderRadius: '10px',
    padding: '14px',
    display: 'grid',
    gap: '12px',
    background: '#f8fafc',
  },
  linkHeaderRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: '12px',
  },
  linkHeaderContent: {
    display: 'grid',
    gap: '4px',
  },
  linkTitle: {
    fontSize: '14px',
    color: '#1a1a1a',
    fontWeight: 600,
  },
  linkHint: {
    margin: 0,
    fontSize: '12px',
    color: '#64748b',
    lineHeight: 1.4,
  },
  linkRow: {
    display: 'grid',
    gridTemplateColumns: '24px minmax(0, 1fr) auto',
    alignItems: 'center',
    gap: '8px',
  },
  linkIndex: {
    width: '24px',
    height: '24px',
    borderRadius: '999px',
    background: '#e2e8f0',
    color: '#334155',
    fontSize: '12px',
    fontWeight: 600,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  linkInput: {
    background: '#ffffff',
  },
  linkAddButton: {
    border: '1px solid #2563eb',
    background: '#2563eb',
    color: '#ffffff',
    borderRadius: '6px',
    fontSize: '12px',
    fontWeight: 600,
    padding: '6px 10px',
    cursor: 'pointer',
    width: 'fit-content',
    fontFamily: 'inherit',
    transition: 'background 0.15s ease, border-color 0.15s ease',
  },
  linkRemoveButton: {
    border: '1px solid #d9d9d9',
    background: '#ffffff',
    color: '#b91c1c',
    borderRadius: '6px',
    fontSize: '12px',
    fontWeight: 500,
    padding: '6px 10px',
    cursor: 'pointer',
    width: 'fit-content',
    fontFamily: 'inherit',
    transition: 'background 0.15s ease, border-color 0.15s ease',
  },
  requiredMark: {
    color: '#dc2626',
    marginLeft: '2px',
    fontWeight: 700,
  },
  documentSection: {
    border: '1px solid #e2e8f0',
    borderRadius: '10px',
    padding: '10px 12px',
    background: '#f8fafc',
    display: 'grid',
    gap: '8px',
  },
  documentCount: {
    fontSize: '12px',
    color: '#334155',
    fontWeight: 600,
  },
  documentList: {
    margin: 0,
    paddingLeft: 0,
    listStyle: 'none',
    display: 'grid',
    gap: '4px',
  },
  documentItemRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '10px',
    padding: '6px 8px',
    borderRadius: '6px',
    background: '#ffffff',
    border: '1px solid #e2e8f0',
  },
  documentItemName: {
    fontSize: '13px',
    color: '#1f2937',
    lineHeight: 1.4,
    overflowWrap: 'anywhere',
  },
  documentRemoveButton: {
    border: '1px solid #d9d9d9',
    background: '#ffffff',
    color: '#b91c1c',
    borderRadius: '6px',
    fontSize: '12px',
    fontWeight: 500,
    padding: '4px 8px',
    cursor: 'pointer',
    width: 'fit-content',
    fontFamily: 'inherit',
    transition: 'background 0.15s ease, border-color 0.15s ease',
    flexShrink: 0,
  },
};